<ion-header>
  <ion-toolbar>
    <ion-row class="update-qty__header">
      <ion-col>
        <div class="update-qty__title">{{ 'cutbank_landing.storeActualQty' | translate }}</div>
      </ion-col>
      <ion-col class="ion-text-right" style="cursor: pointer">
        <img (click)="cancel()" src="assets/common/cross.svg" />
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="update-qty">
    <ion-row class="update-qty__max-range">
      <div>{{ 'cutbank_landing.tagQty' | translate }}</div>
      <div [style.padding-left.px]="2">{{ maxRange }}</div>
    </ion-row>
    <ion-row class="update-qty__actual-qty">
      <div>{{ 'cutbank_landing.actualQty' | translate }}</div>
      <div [style.padding-left.px]="2">{{ selectedActualQty }}</div>
    </ion-row>
    <ion-row class="update-qty__range">
      <ion-range min="1" max="{{ maxRange }}" pin="true" [(ngModel)]="selectedActualQty">
        <ion-icon slot="end" name="add-circle-outline" (click)="add()"></ion-icon>
        <ion-icon slot="start" name="remove-circle-outline" (click)="subtract()"></ion-icon>
      </ion-range>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <div class="update-qty__footer">
    <ion-button (click)="cancel()">{{ 'common.cancel' | translate }}</ion-button>
    <ion-button (click)="save()">{{ 'common.save' | translate }}</ion-button>
  </div>
</ion-footer>
